export default __webpack_public_path__ + "static/media/labelbg01.c98db2b5.png";